import React from "react";

// EXTRAS
import { dateTimeMask } from "../../common/dateMask";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { grey } from "@mui/material/colors";
import { TypographyBoldOnPrint } from "../styled";

export default function OrderTicketGeneralInfos({
  operator,
  createdAt,
  orderType,
  customerName,
  customerOrderCountOnRestaurant,
  deliveryExpectedTime,
}) {
  return (
    <Box sx={{ textTransform: "capitalize" }}>
      {orderType !== "INDOOR" && (
        <TypographyBoldOnPrint
          variant="body2"
          align="center"
          color={grey["900"]}
          gutterBottom
        >
          {customerOrderCountOnRestaurant > 0
            ? `${customerOrderCountOnRestaurant} pedido${
                customerOrderCountOnRestaurant > 1 ? "s" : ""
              } na sua loja`
            : "Primeiro pedido na sua loja!"}
        </TypographyBoldOnPrint>
      )}
      <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
        Cliente: {customerName || "Não Definido"}
      </TypographyBoldOnPrint>
      <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
        Realizado: {dateTimeMask(createdAt)}
      </TypographyBoldOnPrint>
      <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
        Entregar até: {dateTimeMask(deliveryExpectedTime)}
      </TypographyBoldOnPrint>
      {operator?.first_name && (
        <TypographyBoldOnPrint variant="body2" color={grey["900"]} gutterBottom>
          Atendente: {operator?.first_name}
        </TypographyBoldOnPrint>
      )}
      <Divider sx={{ my: "4px" }} />
    </Box>
  );
}
